import React, {useCallback, useEffect, useState, useRef} from 'react'
import Typography from "@mui/material/Typography";
import {Button, Grid, Paper, Stack, Alert, Slide} from "@mui/material";
import ATSnackbar from "../layout/ATSnackbar";
import FNOStraddle from "./FNOStraddle";
import AllPositions from "../demat/AllPositions";
import AllUsersPnL from "../demat/AllUsersPnL";
import {getData} from "../util/__fetch";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter
} from "@mui/x-data-grid";
import websocketService from "../websocket/WebSocketService";
import {useSharedStyles} from "../util/constant";
import FNOStrategy from "./FNOStrategy";

export const FNOControlCentre = ({user}) => {
  const [open, setOpen] = useState(false)
  const [warningMessage, setWarningMessage] = useState("")
  const classes = useSharedStyles()
  const [errorNotifications, setErrorNotifications] = useState([])
  const [userPnlRows, setUserPnlRows] = useState([])
  const [allPositions, setAllPositions] = React.useState([]);
  const [allUsers, setAllUsers] = React.useState([]);
  const [refreshPositions, setRefreshPositions] = React.useState(0);
  const ackNotificationsRef = useRef(new Set());

  //TODO: compare open positions with straddles
  // if there is cumulative quantity mismatch between same strike straddle and open positions, then show warning message

  useEffect(() => {
    getData('/algo-trading/api/fno/active/users', user, setAllUsers, () => {}, () => {})
      .then(response => {});
  }, [user]);

  useEffect(() => {
    websocketService.connect().then(r => {
      websocketService.subscribe('/fno/error-notifications', message => {
            // console.log(message?.body);
            // Ignore if user opted out
            if (ackNotificationsRef.current.has(message?.body)) {
                return;
            }

            const id = Date.now() + Math.random()
          // Add to errors array with unique id
          setErrorNotifications(prev => [
            ...prev,
            {
              id: id,
              message: message?.body,
              timestamp: Date.now(),
            },
          ]);
          setOpen(true);
            setTimeout(() => {
                setErrorNotifications(prev => prev.filter(e => e.id !== id));
            }, 10000);
      });
    })
  }, []);


  const getClassName = useCallback((params, field) => {
    return params.field === field && Number(params.value) > 0 ? classes.profit : classes.loss;
  }, [classes])

  function customToolBar(title) {
    return (
      <GridToolbarContainer title={title} sx={{justifyContent: 'space-between'}}>
        <Typography variant="h6">{title}</Typography>
        <Button onClick={() => setRefreshPositions(prevState => prevState + 1)}>Refresh</Button>
        <GridToolbarFilterButton/>
        <GridToolbarExport/>
        <GridToolbarQuickFilter/>
      </GridToolbarContainer>
    );
  }
   const handleAcknowledge = (id, message) => {
      // remove this alert immediately
      setErrorNotifications((prev) => prev.filter((e) => e.id !== id));

      // store acknowledged message in ref
      ackNotificationsRef.current.add(message);
    };

    const handleClose = (id) => {
      setErrorNotifications((prev) => prev.filter((e) => e.id !== id));
    };

  return (
    <Grid container item xs={12} md={12} spacing={2}>
      <Grid container item xs={12} md={12} spacing={2}>
        &nbsp;
           <Stack
               sx={{
                 position: "fixed",
                 top: '1%',
                 right: '1%',
                 zIndex: 1300,
               }}
               spacing={1.5}
               direction="column-reverse" // newest appears at bottom
             >
               {errorNotifications.map((err) => (
                 <Slide
                   key={err.id}
                   direction="left"
                   in={true}
                   mountOnEnter
                   unmountOnExit
                 >
                   <Alert
                      severity="warning"
                      variant="filled"
                      sx={{ width: '100%' }}
                      onClose={() => handleClose(err.id)}
                      action={
                        <Button
                          color="primary"
                          variant="contained"
                          size="small"
                          onClick={() => handleAcknowledge(err.id, err.message)}
                        >
                          Acknowledge
                        </Button>
                      }
                    >
                      {err.message}
                    </Alert>
                 </Slide>
               ))}
             </Stack>
         )}
        {warningMessage && (
          <ATSnackbar message={warningMessage} open={open} setOpen={setOpen} severity="warning"/>)}
      </Grid>
      <Grid container item xs={12} md={12} direction="row" spacing={2}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper elevation={1} sx={{overflow: 'hidden', padding: 1}}>
            <FNOStraddle
              user={user}
              setOpen={setOpen}
              wm={setWarningMessage}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <Paper elevation={1} sx={{overflow: 'hidden', padding: 1}}>
            <FNOStrategy
              user={user}
              setOpen={setOpen}
              wm={setWarningMessage}
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={12} direction="row" spacing={2}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper elevation={1} sx={{overflow: 'hidden', padding: 1}}>
            <AllPositions source={'fno'} user={user} getClassName={getClassName}
                          allPositions={allPositions}
                          setAllPositions={setAllPositions}
                          refreshPositions={refreshPositions}
                          customToolBar={customToolBar} setUserPnlRows={setUserPnlRows}/>
          </Paper>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={12} direction="row" spacing={2}>
        <Grid item xs={12} md={12} lg={12}>
          <Paper elevation={1} sx={{overflow: 'hidden', padding: 1}}>
            <AllUsersPnL user={user} getClassName={getClassName} allPositions={allPositions}
                         customToolBar={customToolBar} userPnlRows={userPnlRows} allUsers={allUsers}/>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FNOControlCentre